import { LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';

//
// base class for simple API response based <select>s
//
export class TefComsBaseSelect extends LitElement {
  @property({ type: String }) selected: string;
  @query('select', true) select$!: HTMLSelectElement;

  async api<T>(path: string): Promise<T> {
    const response = await fetch(`${this.apiBaseUrl}/${path}`, {
      headers: { Authorization: 'Basic dGVzdHBhZ2U6c2VjcmV0' }, // "testpage:secret"
    });

    if (!response.ok) {
      throw new Error(`Could not fetch data from ${response.url}: ${response.statusText}`);
    }

    return await response.json() as T;
  }

  get apiBaseUrl() {
    const { hostname } = window.location;

    // TODO: Use isLocalhost from MFEC (FS, 29.12.2025)
    if (hostname === 'localhost' || hostname.startsWith('192.168') || hostname.startsWith('10.') || hostname === 'docker') {
      return `http://${hostname}:3000`;
    }

    const { environment, domain } = /^(?<environment>.*?)-micro-frontend-proxy\.(?<domain>.*)$/.exec(hostname)?.groups ?? {};

    if (!environment || !domain) {
      throw new Error(`Could not detect environment and/or domain from hostname "${hostname}"`);
    }

    return `https://${environment}-api-consent.${domain}`;
  }

  // Render to lightDOM
  createRenderRoot() {
    return this;
  }
}
